/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import * as AppointmentActions from '@appointments/store/appointment.actions';
import { AppointmentState, initialState } from '@appointments/store/appointment.state';

export function appointmentReducer(state = initialState, action: AppointmentActions.AppointmentActions): AppointmentState {
  switch (action.type) {
    case AppointmentActions.LOAD_APPOINTMENT:
    case AppointmentActions.LOAD_APPOINTMENTS:
    case AppointmentActions.PERSIST_APPOINTMENT:
      return {
        ...state,
        isActionPending: true
      };
    case AppointmentActions.LOAD_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        isActionPending: false,
        appointments: action.appointments
      };
    case AppointmentActions.LOAD_APPOINTMENT_FAILURE:
    case AppointmentActions.LOAD_APPOINTMENTS_FAILURE:
    case AppointmentActions.PERSIST_APPOINTMENT_FAILURE:
    case AppointmentActions.PERSIST_APPOINTMENT_SUCCESS:
      return {
        ...state,
        isActionPending: false
      };
    case AppointmentActions.LOAD_APPOINTMENT_SUCCESS:
      return {
        ...state,
        currentAppointment: action.appointment,
        isActionPending: false
      };
    default:
      return state;
  }
}
